"use strict";

exports.__esModule = true;
exports.planForAspectsRoute = planForAspectsRoute;
exports.PackingPlanForPath = exports.PlanForSegment = exports.PackingPlanForTitle = void 0;

var _createRoute = require("../../../../../react-static/route/createRoute");

var _getPath = require("../../../../../react-static/route/getPath");

var _slugify = require("../../../../../html/slugify");

var _Packing = require("../Packing");

var _ThingTypesInPlanForTemplate = require("./thingTypesInPlanForTemplate/ThingTypesInPlanForTemplate");

var PackingPlanForTitle = "Plan for Packing Aspects";
exports.PackingPlanForTitle = PackingPlanForTitle;
var PlanForSegment = "plan-for";
exports.PlanForSegment = PlanForSegment;
var PackingPlanForPath = (0, _getPath.getPath)(PlanForSegment, _Packing.PackingPath);
exports.PackingPlanForPath = PackingPlanForPath;

function planForAspectsRoute(rootPath, planForAspects) {
  var planFors = planForAspects.edges.map(function (planForEdge) {
    var planFor = planForEdge.node;
    var planForSlug = (0, _slugify.slugify)(planFor.title);
    var url = (0, _ThingTypesInPlanForTemplate.ThingTypesInPlanForTemplatePath)(planForSlug); // TODO toNumberString function with radix or something

    return {
      id: planFor.id.toString(),
      title: planFor.title,
      url: url
    };
  });
  var route = (0, _createRoute.createRoute)(rootPath, PackingPlanForPath);

  route.getData = function () {
    return {
      path: PackingPlanForPath,
      planFors: planFors
    };
  };

  return route;
}